import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import 'rxjs/Rx';

import { API_URL, API_Juris , API_GetAllJuris, API_GetJurisById, API_UpdateJuris, API_AddJuris, API_DownloadUserDocument } from './apiconfig';
import { Juris } from './index.model';

//import { Http_Header_Request_Options } from '../core/httpheader';
import { HttpHeader } from '../core/httpheader';

@Injectable()
export class JurismgmtService {
    private apiUrl: string;

    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(private http: Http) {
        this.apiUrl = API_URL;
    }

    DownloadAdminDocument(fileName: string): Observable<any> {
        return this.http.post(this.apiUrl + API_Juris + "/" + API_DownloadUserDocument + "?fileName=" + fileName, '', { responseType: ResponseContentType.Blob })
            .map((res) => {
                var blob = new Blob([res.blob()], { type: 'application/pdf' })

                return blob;
            });
    }

    getJurisList(tenantId: string): Promise<Array<Juris>> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this.http
            .get(this.apiUrl + API_Juris + '/' + API_GetAllJuris + '/' + tenantId, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => {
                return response.json() as Array<Juris>;
            })
            .catch(this.handleError);
    }

    getJurisById(jurisId: string): Promise<Juris> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this.http
            .get(this.apiUrl + API_Juris + '/' + API_GetJurisById + '/' + jurisId, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => {
                return response.json() as Juris;
            })
            .catch(this.handleError);
    }

    AddJuris(objJurisModel: Juris): Promise<Juris> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this.http
            .post(this.apiUrl + API_Juris + '/' + API_AddJuris, objJurisModel, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => {
                return response.json() as Juris
            })
            .catch(this.handleError);
    }

    updateJuris(objJurisModel: Juris): Promise<Juris> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this.http
            .put(this.apiUrl + API_Juris + '/' + API_UpdateJuris, objJurisModel, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => {
                return response.json() as Juris
            })
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}






// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/jurismgmt.service.ts